// extracted by mini-css-extract-plugin
export default {"title":"oTmtuk789syvXHXxaJLG","info":"QtlSVnYvaPaBMlj_9QXa","actionButton":"HXGmR880vBXFO62ge99A","switcherButton":"xFBSc4IUwQEDddKiIhrw"};